import { useContext } from 'react';
import { AddProjectContext } from '../../../../../TemporaryConmonents/AddProject/Context/AddProjectContext';

export const useProjectTeamPurchasersRow = () => {
    const { purchases } = useContext(AddProjectContext);
    return { purchases };
};
